import {sortBy} from 'lodash';

/**
 * MLD-8030
 */
export default {
  getContactTypes() {
    return sortBy([
      'Attorney',
      'BDI Employee',
      'Billing/Coding',
      'Biomed',
      'Board Recognized Specialist - Swallowing',
      'Buyer',
      'Cardiologist',
      'Cardiologist - Cath Lab',
      'Cardiologist - CT',
      'Cardiologist - Echo',
      'Cardiologist - Nuclear',
      'Cardiology Director',
      'Cardiology Manager',
      'Cardiology VP',
      'Cath Lab - Chief /Lead Tech',
      'Cath Lab - Clinical Coordinator',
      'Cath Lab Manager',
      'CEO/COO/CFO',
      'Charge Nurse',
      'Clinical Program Director',
      'Clinical Resource Manager',
      'Coach',
      'Construction Manager',
      'Contracts Manager/Director',
      'CT - Chief/Lead Tech',
      'CT Manager',
      'CVL Inventory Coordinator',
      'CVL Manager',
      'CVL Nurse',
      'CVL Tech',
      'DAS Survey Recipient',
      'Department Administrator',
      'Director of Cardiology Services',
      'Director of Endoscopy',
      'Director of Practice Operations',
      'DVM',
      'Echocardiography - Director',
      'Echo Lab Coordinator',
      'Echo Lab Supervisor',
      'Echo Lab Technical Director',
      'Engineer',
      'Exercise Physiologist',
      'Facilities Manager',
      'Fellow Coordinator',
      'Financial Decision Maker',
      'Fluoroscopy Supervisor',
      'Gastroenterologist',
      'Gastroentrologist - Therapeutic',
      'GPO - Account Manager',
      'GPO Employee',
      'Hepatologist',
      'Hospitalist',
      'Influencer',
      'Interventional Radiology Manager',
      'IT Director',
      'IT Manager',
      'IT Technician',
      'Key Decision Maker',
      'Lab Director',
      'Lab Manager',
      'Lead Sonographer',
      'Materials Manager/Director',
      'Medical Director',
      'Mobilizer',
      'MR - Chief/Lead Tech',
      'MR Manager',
      'Nephrologist',
      'Neurologist',
      'Neuroradiologist',
      'Neurosurgeon',
      'NM Medical Director',
      'Nuclear Tech',
      'NucMed Manager',
      'NucMed Physician',
      'Nurse',
      'Nurse Manager',
      'Nurse Practitioner',
      'Nursing - Chief Nursing Officer',
      'OEM Representative',
      'Office Manager',
      'Oncologist',
      'Operations Manager/Director',
      'PACS Manager',
      'Pediatric SLP',
      'PET Manager',
      'PET Technologist',
      'Pharmacist',
      'Pharmacy Buyer',
      'Pharmacy Director',
      'Physician\'s Assistant',
      'Physician Fellow',
      'Physicist',
      'Point of Care Coordinator',
      'Project Manager',
      'Purchasing Director',
      'Purchasing Manager',
      'Radiation Oncologist',
      'Radiation Physicist',
      'Radiation Safety Officer',
      'Radiation Therapist',
      'Radiologist',
      'Radiologist – Breast MR',
      'Radiologist - Cardiac',
      'Radiologist-CT',
      'Radiologist - Interventional',
      'Radiologist-MR',
      'Radiologist-Nuclear Med',
      'Radiologist-Ultrasound',
      'Radiology - Chief/Lead Tech',
      'Radiology Director',
      'Radiology Manager',
      'Radiology Practitioner Assistant',
      'Radiology Tech',
      'Radiology VP',
      'Radiopharmacist',
      'RDCS',
      'RDMS',
      'Receptionist',
      'Reimbursement',
      'Risk Manager',
      'RN',
      'Sonographer',
      'Special Procedures Manager',
      'Speech Language Pathologist',
      'Supply Chain Management',
      'Supply Chain Systems Analyst',
      'Surgeon',
      'Technologist',
      'University Professor',
      'Vascular Surgeon',
      'Vendor/Business Partner',
      'Verifier',
      'VP Supply Chain Management',
    ]);
  },
  getSpecialties() {
    return sortBy([
      'Administration',
      'Anesthesiology - Critical Care',
      'Angiology',
      'Biomedical - Clinical engineering',
      'Body Imaging',
      'Breast Imaging',
      'Cardiology',
      'Cardio Surgery',
      'Echocardiography',
      'Echography',
      'Gastroenterology',
      'General surgery',
      'Internal Medicine',
      'Interventional Radiology',
      'Medical physics',
      'Nephrology',
      'Neurology',
      'Neuroradiology',
      'Neurosurgery',
      'Nuclear Cardiology',
      'Nuclear Cardiology',
      'Nuclear Medicine',
      'Obstetrics and gynaecology',
      'Oncology',
      'Pediatrics',
      'Pharmacy',
      'Purchasing and Supplies',
      'Radiology',
      'Radiotherapy',
      'Speech Pathology',
      'Urology',
      'Vascular Surgery',
      'Veterinary',
    ]);
  }
}
